import { z } from "zod"

export const DocumentSchema = z.object({
  id: z.number(),
  guid: z.string(),
  category_id: z.number().nullable(),
  category_name: z.string().nullable(),
  real_name: z.string(),
  description: z.string(),
  mime_type: z.string(),
  mime_type_title: z.string(),
  mime_type_class: z.string(),
  type: z.number(),
  public: z.boolean(),
  valid_until: z.string().nullable(),
  url: z.string(),
  created_at: z.string().nullable(),
  owner_id: z.number().optional(),
  owner_name: z.string().optional(),
  storage_name: z.string().optional(),
  rules: z.array(z.string()).optional(),
  updated_at: z.string().nullable().optional(),
  is_valid: z.boolean().optional(),
})

export const DocumentFormSchema = z.object({
  category_id: z.number().nullable(),
  description: z.string().min(3),
  valid_until: z.string().nullable().default(null),
  public: z.number().default(0),
  rules: z.array(z.string()).default([]),
})

export type Document = z.infer<typeof DocumentSchema>
export type DocumentFormValues = z.infer<typeof DocumentFormSchema>
